import { render, staticRenderFns } from "./sysStudentInfo.vue?vue&type=template&id=60f9918d&scoped=true&"
import script from "./sysStudentInfo.vue?vue&type=script&lang=js&"
export * from "./sysStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentInfo.vue?vue&type=style&index=0&id=60f9918d&scoped=true&lang=scss&"
import style1 from "./sysStudentInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9918d",
  null
  
)

export default component.exports